import {Outlet} from 'react-router';

/**
 * Pages borrowed from /admin or /staff scroll inside the dashboard's
 * fixed-height panel.
 */
export function DashboardPageFrame() {
  return (
    <div className="h-full min-h-0 overflow-y-auto">
      <Outlet />
    </div>
  );
}
